/**
 * When to reconnect the chat socket ourselves. Kept free of imports so it can
 * be tested on its own.
 *
 * socket.io-client does not retry a connection the server's auth check
 * rejected. The server rejects with 'unauthorized' for a bad token (nothing to
 * retry) and AUTH_UNAVAILABLE when it could not check the token right now
 * (e.g. its database is down), which is worth retrying.
 */

// Must match the chat API's socket/auth.js.
export const AUTH_UNAVAILABLE = 'auth_unavailable'

export const AUTH_RETRY_MS = 5000

export const shouldRetryConnect = (error: { message?: string } | null | undefined, socketActive: boolean): boolean =>
  !socketActive && error?.message === AUTH_UNAVAILABLE
